import { ESCROW_REQUIREMENTS_ACTION_TYPE } from '../actions';

const initialState = {};

const escrowRequirementsSchemaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ESCROW_REQUIREMENTS_ACTION_TYPE.GET_SCHEMA_PARAMS:
      return payload || initialState;

    default:
      return state;
  }
};

export default escrowRequirementsSchemaReducer;
